var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzleRushIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.425 107.072L98.0491 88.0397V49.2716C98.0491 45.3735 94.8982 42.2227 91.0001 42.2227C87.102 42.2227 83.9512 45.3735 83.9512 49.2716V91.5646C83.9512 93.7848 84.9945 95.8785 86.7707 97.2037L114.966 118.35C116.183 119.267 117.665 119.761 119.188 119.76C121.338 119.76 123.453 118.794 124.834 116.933C127.175 113.824 126.541 109.405 123.425 107.072Z",
    fill: "#6366B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 0C40.8195 0 0 40.8195 0 91C0 141.18 40.8195 182 91 182C141.18 182 182 141.18 182 91C182 40.8195 141.18 0 91 0ZM91 167.902C48.6015 167.902 14.0975 133.399 14.0975 91C14.0975 48.6015 48.6015 14.0975 91 14.0975C133.406 14.0975 167.902 48.6015 167.902 91C167.902 133.399 133.399 167.902 91 167.902Z",
    fill: "#6366B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleRushIconHome);
export default __webpack_public_path__ + "static/media/PuzzleRushIcon-Home.97746f04055a4f59d1c3e223e13d215b.svg";
export { ForwardRef as ReactComponent };